"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChart = exports.useTrackMousePosition = void 0;
var react_1 = __importStar(require("react"));
var recharts_1 = require("recharts");
var CustomizedLabel_1 = require("./comps/CustomizedLabel");
var colors_1 = require("../../../themes/colors");
var CustomTooltip_1 = __importDefault(require("./comps/CustomTooltip"));
var usePrepareData_1 = require("../utils/usePrepareData");
var _base_barchart_ui_configs_1 = require("./_base_barchart_ui_configs");
var useTrackMousePosition = function () {
    var _a = (0, react_1.useState)({
        x: 0,
        y: 0,
    }), mousePosition = _a[0], setMousePosition = _a[1];
    (0, react_1.useEffect)(function () {
        var handleMouseMove = function (e) {
            setMousePosition({ x: e.clientX, y: e.clientY });
        };
        window.addEventListener("mousemove", handleMouseMove);
        // Clean up
        return function () {
            window.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);
    return ({ mousePosition: mousePosition });
};
exports.useTrackMousePosition = useTrackMousePosition;
// CHART_OFFSET_TOP is the y shift on top of the entire chart, because otherwise the chart starts with bar 1 at 0,0 coordinates
var CHART_OFFSET_TOP = _base_barchart_ui_configs_1._base_barchart_ui_configs.labelToBarGap +
    _base_barchart_ui_configs_1._base_barchart_ui_configs.labelHeight +
    (_base_barchart_ui_configs_1._base_barchart_ui_configs.labelToNextBarGap / 2 - 2); //this minus 2 is just to correct the extra white space that the labelHeight takes on top of the text
var TOT_HEIGHT_SINGLE_BAR_SECTION = _base_barchart_ui_configs_1._base_barchart_ui_configs.barHeight +
    _base_barchart_ui_configs_1._base_barchart_ui_configs.labelToBarGap +
    _base_barchart_ui_configs_1._base_barchart_ui_configs.labelHeight +
    _base_barchart_ui_configs_1._base_barchart_ui_configs.labelToNextBarGap;
var CALC_SINGLE_BAR_SECTION_Y_POS = function (index) {
    return (TOT_HEIGHT_SINGLE_BAR_SECTION + _base_barchart_ui_configs_1._base_barchart_ui_configs.gapBetweenBarSections) * index;
};
var CALC_TOTAL_HEIGHT_GROUPED_BAR_SECTION = function (noOfBarsInGroup) {
    var totalHeightOfAllBars = noOfBarsInGroup * _base_barchart_ui_configs_1._base_barchart_ui_configs.barHeight +
        (noOfBarsInGroup - 1) * _base_barchart_ui_configs_1._base_barchart_ui_configs.gapBetweenBarsInGroup;
    return (totalHeightOfAllBars +
        _base_barchart_ui_configs_1._base_barchart_ui_configs.labelToBarGap +
        _base_barchart_ui_configs_1._base_barchart_ui_configs.labelHeight +
        _base_barchart_ui_configs_1._base_barchart_ui_configs.labelToNextBarGap);
};
var CALC_GROUPED_BAR_SECTION_Y_POS = function (index, barIndex, noOfBarsInGroup) {
    var TOTAL_HEIGHT_GROUPED_BAR_SECTION = CALC_TOTAL_HEIGHT_GROUPED_BAR_SECTION(noOfBarsInGroup);
    var startYPosOfGroup = (TOTAL_HEIGHT_GROUPED_BAR_SECTION + _base_barchart_ui_configs_1._base_barchart_ui_configs.gapBetweenBarSections) *
        index;
    return (startYPosOfGroup +
        barIndex * (_base_barchart_ui_configs_1._base_barchart_ui_configs.barHeight + _base_barchart_ui_configs_1._base_barchart_ui_configs.gapBetweenBarsInGroup));
};
var CALC_TOTAL_HEIGHT_OF_CHART = function (_a) {
    var isBreakdown = _a.isBreakdown, breakdownDisplayType = _a.breakdownDisplayType, data = _a.data;
    return isBreakdown && breakdownDisplayType === "grouped"
        ? CALC_TOTAL_HEIGHT_GROUPED_BAR_SECTION(data[0].length) *
            data.length +
            _base_barchart_ui_configs_1._base_barchart_ui_configs.gapBetweenBarSections * (data.length - 1) +
            _base_barchart_ui_configs_1._base_barchart_ui_configs.hoverRectStrokeWidth * 2
        : TOT_HEIGHT_SINGLE_BAR_SECTION * data.length +
            _base_barchart_ui_configs_1._base_barchart_ui_configs.gapBetweenBarSections * (data.length - 1) +
            _base_barchart_ui_configs_1._base_barchart_ui_configs.hoverRectStrokeWidth * 2;
};
var _debug_controls = {
    mouseEventDetectorOpacity: 0, //only increase this for debugging. nothing else.
    chartWrapperBgColor: "", //set this to some color value for debugging
};
var barConfigs = {
    isBreakdown: {
        getBarRadius: function (stackIndex, breakdownDisplayType, //replaced breakdownDisplayType
        totalStacks) {
            return breakdownDisplayType === "grouped" //replaced breakdownDisplayType
                ? _base_barchart_ui_configs_1._base_barchart_ui_configs.barRadius
                : stackIndex === totalStacks - 1
                    ? [0, _base_barchart_ui_configs_1._base_barchart_ui_configs.barRadius, _base_barchart_ui_configs_1._base_barchart_ui_configs.barRadius, 0]
                    : stackIndex === 0
                        ? [_base_barchart_ui_configs_1._base_barchart_ui_configs.barRadius, 0, 0, _base_barchart_ui_configs_1._base_barchart_ui_configs.barRadius]
                        : 0;
        },
        getDataKey: function (stackIndex) { return "".concat(stackIndex, ".labels.count"); },
        getStackId: function (stackIndex, breakdownDisplayType //replaced breakdownDisplayType
        ) { return (breakdownDisplayType === "stacked" ? "stack" : "stack-".concat(stackIndex)); },
        getCellFill: function (colorIdx, stackIndex, dataVizColors) { return dataVizColors[(colorIdx + stackIndex) % dataVizColors.length]; },
    },
    isNotBreakdown: {
        getBarRadius: function () { return _base_barchart_ui_configs_1._base_barchart_ui_configs.barRadius; },
        getDataKey: function () { return "labels.count"; },
        getStackId: function () { return undefined; },
        getCellFill: function (colorIdx, _stackIndex, dataVizColors) { return dataVizColors[colorIdx]; },
    },
};
var renderBar = function (_a) {
    var _b = _a.stackIndex, stackIndex = _b === void 0 ? 0 : _b, dataToRender = _a.data, isBreakdownToRender = _a.isBreakdown, breakdownDisplayTypeToRender = _a.breakdownDisplayType, showSumOfBreakdownValues = _a.showSumOfBreakdownValues, 
    //
    colorIdx = _a.colorIdx, showPercent = _a.showPercent, showCount = _a.showCount, activeBar = _a.activeBar, setActiveBar = _a.setActiveBar, onClick = _a.onClick;
    var activeConfig = isBreakdownToRender
        ? barConfigs.isBreakdown
        : barConfigs.isNotBreakdown;
    var totalStacks = isBreakdownToRender
        ? dataToRender[0].length
        : 1;
    var currentStackId = activeConfig.getStackId(stackIndex, breakdownDisplayTypeToRender);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(recharts_1.Bar, { key: "stack-".concat(stackIndex), radius: activeConfig.getBarRadius(stackIndex, breakdownDisplayTypeToRender, totalStacks), dataKey: activeConfig.getDataKey(stackIndex), stackId: currentStackId },
            (!isBreakdownToRender || stackIndex === 0) && (react_1.default.createElement(recharts_1.LabelList, { dataKey: isBreakdownToRender ? function (dataPoint) { return dataPoint; } : "labels", offset: 0, position: "bottom", content: function (props) { return (react_1.default.createElement(CustomizedLabel_1.CustomizedLabel, __assign({ CALC_SINGLE_BAR_SECTION_Y_POS: CALC_SINGLE_BAR_SECTION_Y_POS, TOT_HEIGHT_SINGLE_BAR_SECTION: TOT_HEIGHT_SINGLE_BAR_SECTION, TOT_HEIGHT_GROUPED_BAR_SECTION: isBreakdownToRender &&
                        breakdownDisplayTypeToRender === "grouped"
                        ? CALC_TOTAL_HEIGHT_GROUPED_BAR_SECTION(dataToRender[0].length)
                        : undefined,
                    breakdownDisplayType: breakdownDisplayTypeToRender,
                    y: props.y,
                    width: props.width,
                    height: props.height,
                    value: isBreakdownToRender
                        ? dataToRender[props.index].map(function (item, idx) { return (__assign(__assign({}, item.labels), { color: colors_1.dataVizColorsText[(colorIdx + idx) % colors_1.dataVizColorsText.length] })); })
                        : props.value, showPercent: showPercent, showCount: showCount, showSumOfBreakdownValues: showSumOfBreakdownValues, opacity: 1, activeBar: activeBar, _base_barchart_ui_configs: _base_barchart_ui_configs_1._base_barchart_ui_configs, _debug_controls: _debug_controls }, (onClick
                    ? {
                        onMouseOver: function (e, value) {
                            setActiveBar(isBreakdownToRender
                                ? dataToRender[props.index][0].labels.name
                                : value.name);
                        },
                        onMouseOut: function () { return setActiveBar(undefined); },
                        onMouseDown: function (e, value) {
                            var name = isBreakdownToRender
                                ? dataToRender[props.index][0].labels.name
                                : value.name;
                            setActiveBar(name);
                            onClick(name);
                        },
                    }
                    : {})))); } })),
            dataToRender.map(function (d, index) { return (react_1.default.createElement(recharts_1.Cell, { y: !isBreakdownToRender || breakdownDisplayTypeToRender === "stacked"
                    ? CALC_SINGLE_BAR_SECTION_Y_POS(index) + CHART_OFFSET_TOP
                    : CALC_GROUPED_BAR_SECTION_Y_POS(index, stackIndex, dataToRender[0].length) + CHART_OFFSET_TOP, key: "cell-".concat(index, "-").concat(stackIndex), opacity: 1, height: _base_barchart_ui_configs_1._base_barchart_ui_configs.barHeight, fill: activeConfig.getCellFill(colorIdx, stackIndex, colors_1.dataVizColors) })); }))));
};
var BarChartRenderer = function (_a) {
    var data = _a.data, isBreakdown = _a.isBreakdown, breakdownDisplayType = _a.breakdownDisplayType, showSumOfBreakdownValues = _a.showSumOfBreakdownValues, colorIdx = _a.colorIdx, showPercent = _a.showPercent, showCount = _a.showCount, activeBar = _a.activeBar, setActiveBar = _a.setActiveBar, onClick = _a.onClick, 
    //
    mousePosition = _a.mousePosition, dataMaxValue = _a.dataMaxValue;
    return (react_1.default.createElement(recharts_1.BarChart, { width: 500, height: CALC_TOTAL_HEIGHT_OF_CHART({
            isBreakdown: isBreakdown,
            breakdownDisplayType: breakdownDisplayType,
            data: data
        }), data: data, layout: "vertical", margin: {
            top: 0,
            right: _base_barchart_ui_configs_1._base_barchart_ui_configs.marginRight,
            left: _base_barchart_ui_configs_1._base_barchart_ui_configs.marginLeft,
            bottom: 0,
        } },
        react_1.default.createElement(recharts_1.XAxis, { hide: true, type: "number", domain: [0, dataMaxValue] }),
        react_1.default.createElement(recharts_1.YAxis, { hide: true, type: "category" }),
        isBreakdown && (react_1.default.createElement(recharts_1.Tooltip, { content: function (props) {
                var _a;
                return (react_1.default.createElement(CustomTooltip_1.default, __assign({}, props, { mousePosition: mousePosition, showPercent: showPercent, 
                    // god knows why the dataindex gets stored against props.label.
                    // this is some internal recharts thing for tooltips specifically.
                    // we dont do this.
                    value: (_a = data[props.label]) === null || _a === void 0 ? void 0 : _a.map(function (item, idx) { return (__assign(__assign({}, item.labels), { color: colors_1.dataVizColors[(colorIdx + idx) % colors_1.dataVizColors.length] })); }) })));
            }, cursor: false, allowEscapeViewBox: { x: true, y: true } })),
        isBreakdown
            ? data[0].map(function (_, stackIndex) {
                return renderBar({
                    stackIndex: stackIndex,
                    data: data,
                    isBreakdown: isBreakdown,
                    breakdownDisplayType: breakdownDisplayType,
                    showSumOfBreakdownValues: showSumOfBreakdownValues,
                    colorIdx: colorIdx,
                    showPercent: showPercent,
                    showCount: showCount,
                    activeBar: activeBar,
                    setActiveBar: setActiveBar,
                    onClick: onClick,
                });
            })
            : renderBar({
                stackIndex: undefined,
                data: data,
                isBreakdown: isBreakdown,
                breakdownDisplayType: breakdownDisplayType,
                showSumOfBreakdownValues: showSumOfBreakdownValues,
                colorIdx: colorIdx,
                showPercent: showPercent,
                showCount: showCount,
                activeBar: activeBar,
                setActiveBar: setActiveBar,
                onClick: onClick,
            })));
};
var BarChart = function (_a) {
    var _data = _a.data, valuePath = _a.valuePath, tooltipLabelsMapping = _a.tooltipLabelsMapping, tooltipLabelsPath = _a.tooltipLabelsPath, _b = _a.labelPath, labelPath = _b === void 0 ? "name" : _b, onClick = _a.onClick, _c = _a.breakdownDisplayType, breakdownDisplayType = _c === void 0 ? "grouped" : _c, _d = _a.showCount, showCount = _d === void 0 ? true : _d, _e = _a.showPercent, showPercent = _e === void 0 ? true : _e, _f = _a.colorIdx, colorIdx = _f === void 0 ? 0 : _f, _g = _a.summarizeAfterIdx, summarizeAfterIdx = _g === void 0 ? 5 : _g;
    var isBreakdown = Array.isArray(valuePath);
    var _h = (0, usePrepareData_1.usePrepareData)({
        _data: _data,
        labelPath: labelPath,
        valuePath: valuePath,
        tooltipLabelsMapping: tooltipLabelsMapping,
        tooltipLabelsPath: tooltipLabelsPath,
        isBreakdown: isBreakdown,
        showPercent: showPercent,
        summarizeAfterIdx: summarizeAfterIdx,
    }), data = _h.data, dataMaxValue = _h.dataMaxValue, dataToSummarize = _h.dataToSummarize;
    var _j = (0, react_1.useState)(undefined), activeBar = _j[0], setActiveBar = _j[1];
    var mousePosition = (0, exports.useTrackMousePosition)().mousePosition;
    // menu options for grouped and stacked
    return (react_1.default.createElement("div", { style: {
            height: "".concat(CALC_TOTAL_HEIGHT_OF_CHART({
                isBreakdown: isBreakdown,
                breakdownDisplayType: breakdownDisplayType,
                data: data
            }) + (isBreakdown ? 0 : CALC_TOTAL_HEIGHT_OF_CHART({
                isBreakdown: true,
                breakdownDisplayType: 'stacked',
                data: dataToSummarize
            })), "px"),
            width: "100%",
            background: _debug_controls.chartWrapperBgColor,
        } },
        react_1.default.createElement(recharts_1.ResponsiveContainer, { width: "100%", height: "100%" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(BarChartRenderer, { data: data, isBreakdown: isBreakdown, breakdownDisplayType: breakdownDisplayType, showSumOfBreakdownValues: false, colorIdx: colorIdx, showPercent: showPercent, showCount: showCount, activeBar: activeBar, setActiveBar: setActiveBar, onClick: onClick, mousePosition: mousePosition, dataMaxValue: dataMaxValue }),
                dataToSummarize && (react_1.default.createElement(BarChartRenderer, { data: dataToSummarize,
                    isBreakdown: true,
                    breakdownDisplayType: "stacked",
                    showSumOfBreakdownValues: true, colorIdx: colorIdx, showPercent: showPercent, showCount: showCount, activeBar: activeBar, setActiveBar: setActiveBar, onClick: onClick, mousePosition: mousePosition, dataMaxValue: dataMaxValue }))))));
};
exports.BarChart = BarChart;
